import EditNameModal from "components/Common/Modal/MyAccount/EditName";
import {
  ModalsStateContext,
  ModalsDispatchContext,
} from "./MyAccountModal.context";
import EditPasswordModal from "components/Common/Modal/MyAccount/EditPassword";
import useMyAccountModal from "src/hooks/Modal/MyAccount/useMyAccountModal";

interface IModalProvider {
  children: React.ReactNode;
}
const MyAccountModalsProvider = ({ children }: IModalProvider) => {
  const {
    showEditNameModal,
    showEditEmailModal,
    showEditPasswordModal,
    showEditMemberModal,
    showEditDrawalMemberModal,
    setShowEditNameModal,
    setShowEditEmailModal,
    setShowEditPasswordModal,
    setShowEditMemberModal,
    setShowEditDrawalMemberModal,
  } = useMyAccountModal();

  const dispatch = { setShowEditPasswordModal, setShowEditNameModal };
  const state = {};

  return (
    <ModalsDispatchContext.Provider value={dispatch}>
      <ModalsStateContext.Provider value={state}>
        {children}
        {showEditPasswordModal && (
          <EditPasswordModal
            showEditPasswordModal={showEditPasswordModal}
            setShowEditPasswordModal={setShowEditPasswordModal}
          />
        )}
        {showEditNameModal && (
          <EditNameModal
            showEditNameModal={showEditNameModal}
            setShowEditNameModal={setShowEditNameModal}
          />
        )}
      </ModalsStateContext.Provider>
    </ModalsDispatchContext.Provider>
  );
};

export default MyAccountModalsProvider;
